import { render, staticRenderFns } from "./staff-static.vue?vue&type=template&id=07e78af8"
import script from "./staff-static.vue?vue&type=script&lang=js"
export * from "./staff-static.vue?vue&type=script&lang=js"
import style0 from "./staff-static.vue?vue&type=style&index=0&id=07e78af8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports